import { render, staticRenderFns } from "./bomShenpi.vue?vue&type=template&id=021b66ec"
import script from "./bomShenpi.vue?vue&type=script&lang=js"
export * from "./bomShenpi.vue?vue&type=script&lang=js"
import style0 from "./bomShenpi.vue?vue&type=style&index=0&id=021b66ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports